module.exports = __webpack_public_path__ + "img/fifa_t_back.f1c324e0.jpg";